import { Box, SxProps, Typography } from '@mui/material';
import { Button } from 'system/atoms';
import { RadioGroup } from 'components/RadioGroup';
import { AnchorText } from 'components/Text';
import { useState } from 'react';
import {
  whatsAppOnboardingStepMapper,
  WhatsAppOnboardingSteps
} from '../constants';
import { useDrawer } from 'services/drawer/hooks';

const buttonsContainer: SxProps = {
  display: 'flex',
  gap: 1,
  mt: 2
};

type Props = {
  handleNext: (step: number) => void;
};

export const MetaBusinessAccountStep: React.FC<Props> = ({ handleNext }) => {
  const [value, setValue] = useState<'yes' | 'no' | undefined>();
  const [error, setError] = useState<boolean>(false);
  const { closeDrawer } = useDrawer();

  const moveToNextStep = () => {
    if (value === 'yes') {
      handleNext(
        whatsAppOnboardingStepMapper[WhatsAppOnboardingSteps.PHONE_NUMBER]
      );
      return;
    }

    if (value === 'no') {
      handleNext(
        whatsAppOnboardingStepMapper[
          WhatsAppOnboardingSteps.SETUP_META_BUSINESS_ACCOUNT
        ]
      );
      return;
    }

    setError(true);
  };

  return (
    <Box>
      <Box>
        <RadioGroup
          label={
            <>
              <Typography
                fontWeight="bold"
                color={error ? 'error' : 'text.primary'}
              >
                Do you have a Meta Business account?
              </Typography>

              <AnchorText
                onClick={() => {
                  window.open('https://business.facebook.com/', '_blank');
                }}
              >
                Learn about Meta Business accounts
              </AnchorText>

              {error && (
                <Typography variant="body2" color="error">
                  If you're not sure, select "no" and Popp can guide you{' '}
                </Typography>
              )}
            </>
          }
          onChange={(value) => {
            if (value.target.value === 'yes' || value.target.value === 'no') {
              setValue(value.target.value);
            }
          }}
          options={[
            {
              value: 'yes',
              label: 'Yes'
            },
            {
              value: 'no',
              label: 'No'
            }
          ]}
        />
      </Box>

      <Box sx={buttonsContainer}>
        <Button variant="primary" onClick={moveToNextStep}>
          Next
        </Button>
        <Button
          onClick={() => {
            closeDrawer();
          }}
        >
          Cancel
        </Button>
      </Box>
    </Box>
  );
};
